import axios, { AxiosInstance } from 'axios'

interface axiosInstance {
    [key: string]: AxiosInstance
}

const axiosInstanceBuilder = (type: string): AxiosInstance => {
    const axiosInstance: axiosInstance = {
        accounts: axios.create({
            baseURL: 'https://accounts.r2.protoduct.ir',
        }),
        api: axios.create({
            baseURL: process.env.REACT_APP_TICKET_URL,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        }),
    }
    axiosInstance['api'].interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('token')
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
            }
            return config
        },
        (error) => Promise.reject(error)
    )
    axiosInstance['api'].interceptors.response.use(
        (response) => response,
        async (error) => {
            return Promise.reject(error)
        }
    )
    return axiosInstance[type]
}
export default axiosInstanceBuilder
